export enum VideoAnalyticsTrackerType {
    Matomo = 'Matomo',
    GoogleAnalytics = 'GoogleAnalytics',
    BrowserConsole = 'BrowserConsole',
    ShinyStat = 'ShinyStat',
    Garavot = 'Garavot'
}
